import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n} from 'vue-i18n'
import en from "@/modules/i18n/en";
import zh from "@/modules/i18n/zh";

//remove all console log in production
/*if (process.env.VUE_APP_MODE  === "release_jp") {
    console.log = function () {};
}*/

const config = {
    legacy: false,
    globalInjection:true,
    locale: 'zh', // set default locale
    fallbackLocale: 'en', // set fallback locale
    messages: {
        'zh': zh,
        'en': en
    },
}

//Create i18n instance with options
const i18n = createI18n(config)
const app = createApp(App)

app.provide('i18n', i18n.global);
app.use(router);
app.mount('#app');

//Set the main site title
document.title = i18n.global.t("label_doc_title");